/**
 * Environment-Aware Logger
 * Provides detailed logging in development while maintaining privacy and performance in production.
 */

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
  /**
   * Warning messages (dev: full console, prod: silent)
   * @param {string} message - Warning message
   * @param {any} data - Additional data to log
   */
  warn: (message, data) => {
    if (isDevelopment) {
      console.warn('⚠️ WARNING:', message, data);
    }
    // Production: silent
  },

  /**
   * General events (dev: console, prod: silent)
   * @param {string} message - Event message
   * @param {any} data - Additional data to log
   */
  log: (message, data) => {
    if (isDevelopment) {
      console.log('🔍 EVENT:', message, data);
    }
    // Production: silent
  },

  /**
   * Error messages (dev: full details, prod: silent)
   * @param {string} message - Error message
   * @param {any} data - Additional data to log
   */
  error: (message, data) => {
    if (isDevelopment) {
      console.error('❌ ERROR:', message, data);
    }
    // Production: completely silent
  },

  /**
   * Debug information (dev: verbose, prod: completely silent)
   * @param {string} message - Debug message
   * @param {any} data - Additional data to log
   */
  debug: (message, data) => {
    if (isDevelopment) {
      console.log('🔧 DEBUG:', message, data);
    }
    // Production: completely silent
  },

  /**
   * General info logging (dev: console, prod: silent)
   * @param {string} message - Info message
   * @param {any} data - Additional data to log
   */
  info: (message, data) => {
    if (isDevelopment) {
      console.log('ℹ️ INFO:', message, data);
    }
    // Production: silent
  }
};

export default logger;
